import React from 'react';
import styled from 'styled-components';

const FooterWrapper = styled.div`
  display: flex;
  padding: 18px;
  justify-content: space-between;
  background-color: #da9c15;
  color: #fff;
  @media (max-width: 768px){
    font-size: 12px;
  }
  @media (max-width: 660px){
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-top: 10px;
  }
  @media (max-width: 415px){
    padding-top: 5px;
  }
  a {
    color: #fff;
  }
  i {
    padding-top: 5px;
    color: #ed0000;
  }
`;

const Footer = () => (
  <FooterWrapper>
    <div><strong>© 2017<a href="" rel="noopener noreferrer" target="_blank"> Департамент охорони здоров'я.</a></strong> Усі права захищено.</div>
    <div>З великою <i className="fa fa-heart text-red"/> Ваш <a href="http://30meridian.com/" rel="noopener noreferrer" target="_blank">"30th Meridian LTD"</a></div>
  </FooterWrapper>
)

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js